import React, { FC } from 'react'

import { Dialog } from 'components'

import { MessagesDialogProps } from './MessagesDialog.props'
import './MessageDialog.scss'

const MessageDialog: FC<MessagesDialogProps> = ({ isVisible, body, action, dataTest, classList }) => (
  <Dialog
    classList={classList}
    dataTest={dataTest}
    visible={isVisible}
    body={<div dangerouslySetInnerHTML={{ __html: `${body}` }} />}
    onOk={{
      name: 'OK',
      action
    }}
  />
)

export default MessageDialog
